import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLinkWithHref } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ModalComponent } from '../../components/modal/modal.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { UniversityService } from '../../services/university.service';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { ButtonComponent } from '../../components/button/button.component';
import { ExamService } from '../../services/exam.service';
import { FormsModule } from '@angular/forms';
import { PaymentService } from '../../services/payment.service';
import { ReEvaluationService } from '../../services/re-evaluation.service';
import { DropdownService } from '../../services/dropdown.service';
import { HttpService } from '../../services/http.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-student-portal-list-page',
  imports: [HeaderComponent, CommonModule, ModalComponent, PluralPipe, AgGridListComponent, ListActionButtonsComponent, SelectInputComponent, SearchInputComponent, ButtonComponent, RouterLinkWithHref, FormsModule],
  templateUrl: './student-portal-list-page.component.html',
})
export class StudentPortalListPageComponent {
  @ViewChild('re_evaluate_modal') re_evaluate_modal: ModalComponent | undefined;
  @ViewChild('exam_dropdown') exam_dropdown: SelectInputComponent | undefined;
  page_name = 'Exam Results';
  params: any = {};
  selected_item: any = {};
  items: any = [];
  is_submitting = false;
  academic_year_id: any = null;
  academic_year: any;
  selected_exam_id: any = '';
  selected_academic_year_id: any = '';
  student_exam_list: any[] = [];
  private _suppress_exam_change = false;

  city_cols: any = [
    { field: 'subject.name', headerName: 'Subject Name', filter: true, minWidth: 180, flex: 2, valueGetter: (params: any) => { const s = params.data?.subject; return s ? (s.code ? `${s.name} (${s.code})` : s.name) : '-'; } },
    { field: 'total_marks', headerName: 'Total Marks', filter: true, minWidth: 120, flex: 1 },
    { field: 'marks_obtained', headerName: 'Marks Obtained', filter: true, minWidth: 130, flex: 1, cellRenderer: (params: any) => { const marks = params.data?.marks_obtained; return marks !== null && marks !== undefined ? marks : 'N/A'; } },
    {
      field: 'result',
      headerName: 'Result',
      filter: true,
      minWidth: 120,
      flex: 1,
      cellRenderer: (params: any) => {
        const marks = params.data?.marks_obtained;
        const passing = params.data?.passing_marks;
        if (marks === null || marks === undefined) return '<span style="background:#FFF3CD;color:#856404;padding:4px 14px;border-radius:20px;font-size:13px;font-weight:600;">Pending</span>';
        const isPassed = marks >= passing;
        return isPassed
          ? '<span style="background:#D1FAE5;color:#065F46;padding:4px 14px;border-radius:20px;font-size:13px;font-weight:600;">Passed</span>'
          : '<span style="background:#FFE4E6;color:#9F1239;padding:4px 14px;border-radius:20px;font-size:13px;font-weight:600;">Failed</span>';
      }
    },
    // {
    //   field: 're_evaluation_status',
    //   headerName: 'Re-evaluation',
    //   filter: false,
    //   minWidth: 170,
    //   flex: 1,
    //   valueGetter: (p: any) => p.data?.re_evaluation_status || '-',
    //   cellRenderer: (p: any) => {
    //     const status = p.data?.re_evaluation_status;
    //     if (!status) return '-';
    //     if (status === 'Pending' || status === 'In Progress') {
    //       return '<span style="font-style:italic;color:#6b7280;font-size:13px;">Sent for Re-Evaluation</span>';
    //     }
    //     if (status === 'Completed') {
    //       return '<span style="background:#D1FAE5;color:#065F46;padding:4px 14px;border-radius:20px;font-size:13px;font-weight:600;">Re-evaluated</span>';
    //     }
    //     return status;
    //   }
    // },
    { field: 'application_last_date', headerName: 'Application Last Date', filter: true, minWidth: 160, flex: 1, valueGetter: (params: any) => { const d = params.data?.application_last_date; if (!d) return '-'; const date = new Date(d); const dd = String(date.getDate()).padStart(2, '0'); const mm = String(date.getMonth() + 1).padStart(2, '0'); const yyyy = date.getFullYear(); return `${dd}-${mm}-${yyyy}`; } },
    { headerName: "Actions", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' }, cellRendererParams: { actions: this.actions.bind(this), align: 'end', inline: true }, editable: false, pinned: 'right', width: 260, minWidth: 260, maxWidth: 260 },
  ];

  re_evaluation_reasons = [
    { title: 'Marks not as expected', value: 'Marks not as expected' },
    { title: 'Subjective answers need recheck', value: 'Subjective answers need recheck' },
    { title: 'Not Satisfied with Evaluation', value: 'Not Satisfied with Evaluation' },
    { title: 'Incorrect Calculation', value: 'Incorrect Calculation' },
    { title: 'All Questions not Evaluated', value: 'All Questions not Evaluated' },
  ];
  re_evaluation_reason: string = '';

  is_eligible_for_re_evaluation(row: any): boolean {
    const log = (reason: string, extra?: any) => console.log('[re-eval-eligibility]', row?.subject?.code || row?.subject?.name || '?', reason, extra ?? '');
    if (!row?.script_id && !row?.script?.id) { log('FAIL: no script_id', { script_id: row?.script_id, nested: row?.script?.id }); return false; }
    if (row?.re_evaluation_status === 'Pending' || row?.re_evaluation_status === 'In Progress') { log('FAIL: status', row?.re_evaluation_status); return false; }
    if (row?.re_evaluation_head_status === 'Pending' || row?.re_evaluation_head_status === 'In Progress') { log('FAIL: he_status', row?.re_evaluation_head_status); return false; }
    if (!row?.re_evaluation_required) { log('FAIL: re_evaluation_required falsy', row?.re_evaluation_required); return false; }
    if (row?.marks_obtained === null || row?.marks_obtained === undefined) { log('FAIL: marks_obtained null', row?.marks_obtained); return false; }
    const last_date_str = row?.re_evaluation_details?.re_evaluation_last_date;
    if (last_date_str) {
      const window_close = new Date(last_date_str);
      window_close.setHours(23, 59, 59, 999);
      if (new Date() > window_close) { log('FAIL: window closed', { last_date_str, window_close, now: new Date() }); return false; }
    }
    const grace_raw = row?.grace_period_expiry;
    if (grace_raw) {
      const grace_close = new Date(grace_raw);
      if (!isNaN(grace_close.getTime()) && grace_close.getTime() > Date.now()) { log('FAIL: grace active', { grace_raw, grace_close, now: new Date() }); return false; }
    }
    log('PASS', { used: Number(row?.re_evaluation_attempt_count ?? 0), re_evaluation_required: row?.re_evaluation_required, status: row?.re_evaluation_status });
    return true;
  }

  actions(row: any) {
    const actions: any[] = [];
    const re_eval_status = row?.re_evaluation_status;
    const attempt_count = Number(row?.re_evaluation_attempt_count ?? 0);
    const has_been_re_evaluated = re_eval_status === 'Completed' || row?.is_re_evaluated === true || attempt_count > 0;
    const eligible = this.is_eligible_for_re_evaluation(row);

    const re_eval_head_status = row?.re_evaluation_head_status;
    if (re_eval_status === 'Pending' || re_eval_status === 'In Progress' || re_eval_head_status === 'Pending' || re_eval_head_status === 'In Progress') {
      actions.push({ type: 'text', text: 'Sent For Re-Evaluation', class: 'italic text-[#6b7280] text-[13px]' });
    } else if (eligible) {
      const next_attempt = attempt_count + 1;
      const label = attempt_count > 0 ? `Re-Evaluate (Attempt ${next_attempt})` : 'Re-Evaluate';
      actions.push({ type: 'button', text: label, function: this.re_evaluate_modal_open.bind(this) });
    } else if (has_been_re_evaluated) {
      actions.push({ type: 'text', text: 'Re-evaluated', class: 'text-[#065F46] text-[13px] font-semibold' });
    }
    actions.push({ type: 'icon-filled', icon: 'bx bx-eye', text: 'View', function: this.open_view_modal.bind(this) });
    return actions;
  }

  constructor(
    public gs: GlobalService,
    public route: Router,
    public us: UniversityService,
    public ar: ActivatedRoute,
    public es: ExamService,
    public ps: PaymentService,
    public res: ReEvaluationService,
    public ds: DropdownService,
    public http: HttpService,
    public userSvc: UserService,
  ) { }

  async ngOnInit() {
    this.ar.queryParams.subscribe(async (params: any) => {
      const { payment, request_id, reason, ...rest } = params || {};
      this.params = { ...rest };
      if (payment) {
        await this.handle_payment_redirect({ payment, request_id, reason });
      }
    });
    await this.ds.get_dropdown_list(['academic-year']);
    if (!this.gs.user_data?.student_mappings?.length) {
      try {
        const profile: any = await this.userSvc.get_profile();
        if (profile?.data) {
          this.gs.user_data = { ...this.gs.user_data, ...profile.data, token: this.gs.user_data?.token };
        }
      } catch (_) { }
    }

    // Preselect the current academic year rather than whatever happens to be first in the
    // list. Runs regardless of whether the profile fetch above was needed — the mappings
    // only decide if we have to reload the profile, not which year the student should land on.
    const query_params = this.ar.snapshot.queryParams;
    const academic_year_id = query_params['academic_year_id']
      ? Number(query_params['academic_year_id'])
      : this.resolve_current_academic_year();
    this.academic_year = academic_year_id;
    this.academic_year_id = academic_year_id;
    this.selected_academic_year_id = academic_year_id ?? '';

    this.build_student_exam_list();
    // The exam dropdown patches its own first value and fires on_exam_change -> get_list.
    // With no exams for this year nothing would trigger it, so load the (empty) list here.
    if (!this.student_exam_list.length) {
      this.get_list();
    }
  }

  // Current academic year = the one whose start/end window contains today. The API field
  // names are `start_date` / `end_date` (see AcademicYears) — the dashboard's copy of this
  // check reads `from_date` / `to_date`, which are always undefined, so its window match is
  // dead and it silently lands on the title fallback.
  // Falls back to a title match, then to the first option, so the filter is never left empty.
  resolve_current_academic_year() {
    const list: any[] = this.ds.dropdown_list?.academic_list || [];
    const current_date = new Date();
    const current_year = current_date.getFullYear();
    const in_window = list.find((item: any) => {
      const start_date = new Date(item.start_date);
      const end_date = new Date(item.end_date);
      if (isNaN(start_date.getTime()) || isNaN(end_date.getTime())) return false;
      return current_date >= start_date && current_date <= end_date;
    });
    if (in_window) return in_window.value;
    const by_title = list.find((item: any) =>
      item.title?.includes(current_year + '-' + (current_year + 1))
      || item.title?.includes((current_year) + '-' + (current_year + 1))
    );
    return by_title?.value ?? list[0]?.value ?? null;
  }

  pending_failed_request_id: string | null = null;
  is_retrying_payment = false;

  private async handle_payment_redirect(params: any) {
    const status: string = (params?.payment || '').toLowerCase();
    const request_id: string = params?.request_id || '';

    let confirmed_status = status;
    if (request_id) {
      try {
        const res: any = await this.res.get_payment_status(request_id);
        const ps = (res?.data?.payment_status || '').toLowerCase();
        if (ps === 'success') confirmed_status = 'success';
        else if (ps === 'cancelled') confirmed_status = 'cancelled';
        else if (ps === 'expired') confirmed_status = 'cancelled';
        else if (ps === 'failed') confirmed_status = 'failed';
      } catch { /* fall back to redirect param */ }
    }

    if (confirmed_status === 'success') {
      this.gs.toastr_shows_function('Payment successful. Re-evaluation application submitted successfully', 'Success', 'success');
      this.pending_failed_request_id = null;
    } else if (confirmed_status === 'cancelled') {
      this.gs.toastr_shows_function('Re-evaluation process cancelled.', 'Info', 'info');
      this.pending_failed_request_id = request_id || null;
    } else if (confirmed_status === 'failed' || confirmed_status === 'error') {
      this.gs.toastr_shows_function('Payment unsuccessful. Re-evaluation application not submitted', 'Error', 'error');
      this.pending_failed_request_id = request_id || null;
    }

    // Clear the query params so a page refresh doesn't re-fire the toast
    this.route.navigate([], { relativeTo: this.ar, queryParams: {}, replaceUrl: true });
  }

  build_student_exam_list() {
    const mappings: any[] = this.gs.user_data?.student_mappings || [];
    const ay_id = this.selected_academic_year_id ? Number(this.selected_academic_year_id) : null;
    if (!ay_id) {
      this.student_exam_list = [];
      return;
    }
    const scoped = mappings.filter((m: any) => Number(m?.AcademicYear?.id ?? m?.academic_year_id) === ay_id);
    const seen = new Set<number>();
    this.student_exam_list = scoped
      .filter((m: any) => m?.Exam?.id && !seen.has(m.Exam.id) && seen.add(m.Exam.id))
      .map((m: any) => ({ ...m.Exam, title: m.Exam.name, value: m.Exam.id }));
  }

  async get_list(filter?: any) {
    try {
      filter = {
        ...filter,
        release_status: 'released',
        ...(this.selected_exam_id && { exam_id: this.selected_exam_id }),
        ...(this.selected_academic_year_id && { academic_year_id: this.selected_academic_year_id }),
      };
      const res = await this.es.get_exam_result_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;
      res.data = res.data.map((item: any, index: number) => {
        const script = item.scripts?.[0] || {};
        const marks_obtained = script.obtained_marks ?? null;
        const total_marks = script.total_marks ?? item.total_marks ?? null;
        const passing_marks = script.passing_marks ?? item.passing_marks ?? null;
        return {
          ...item,
          SrNo: startindex + index + 1,
          marks_obtained,
          total_marks,
          passing_marks,
          script_id: script.id,
          roll_number: script.roll_number,
          re_evaluation_status: script.re_evaluation_status ?? null,
          re_evaluation_head_status: script.re_evaluation_head_status ?? null,
          re_evaluation_attempt_count: script.re_evaluation_attempt_count ?? 0,
          is_re_evaluated: script.is_re_evaluated ?? false,
          grace_period_expiry: script.grace_period_expiry ?? null,
          application_last_date: item.re_evaluation_details?.re_evaluation_last_date ?? null,
          result_status: marks_obtained !== null && marks_obtained !== undefined ? (marks_obtained >= passing_marks ? 'Passed' : 'Failed') : 'Pending'
        };
      });
      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Result list:", error);
    }
  }

  on_exam_change(event: any) {
    if (this._suppress_exam_change) return;
    this.selected_exam_id = event?.value?.id || event?.value || '';
    const mappings: any[] = this.gs.user_data?.student_mappings || [];
    const matched = mappings.find((m: any) => m?.Exam?.id == this.selected_exam_id);
    if (matched) {
      this.gs.user_data = { ...this.gs.user_data, student_mapping: matched };
    }
    this.get_list();
  }

  on_academic_year_change(event: any) {
    this.selected_academic_year_id = event?.value?.id || event?.value || '';
    this.selected_exam_id = '';
    this._suppress_exam_change = true;
    this.exam_dropdown?.reset();
    this._suppress_exam_change = false;
    this.build_student_exam_list();
    this.items = { data: [], count: 0 };
    if (this.selected_academic_year_id && this.student_exam_list.length) {
      return;
    }
    this.get_list();
  }

  async download() {
    try {
      const rows: any[] = this.items?.data || [];
      if (!rows.length) {
        this.gs.toastr_shows_function('No results to download', 'Info', 'info');
        return;
      }

      const headers = ['Subject Name', 'Total Marks', 'Marks Obtained', 'Result', 'Re-evaluation', 'Application Last Date'];
      const escape_csv = (v: any) => {
        if (v === null || v === undefined) return '';
        const s = String(v);
        return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
      };
      let csv = headers.join(',') + '\n';
      for (const row of rows) {
        const marks = row?.marks_obtained;
        const passing = row?.passing_marks;
        let result: string;
        if (marks === null || marks === undefined) result = 'Pending';
        else result = marks >= passing ? 'Passed' : 'Failed';
        const re_eval = row?.re_evaluation_status || '-';
        csv += [
          escape_csv(row?.subject?.name || '-'),
          escape_csv(row?.total_marks ?? '-'),
          escape_csv(marks ?? 'N/A'),
          escape_csv(result),
          escape_csv(re_eval),
          escape_csv(row?.application_last_date || '-'),
        ].join(',') + '\n';
      }

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Exam_Results_${new Date().toISOString().slice(0, 10)}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.message || 'Download failed', 'Error', 'error');
    }
  }

  open_view_modal(item: any, _index?: any) {
    this.selected_item = item;
    const release_meta = Array.isArray(item?.release_metadata) ? item.release_metadata : [];
    const script_id = item?.script_id || release_meta[0]?.script_id;
    if (!script_id) return;
    this.route.navigate(['/student-portal/script-view'], { queryParams: { script_id } });
  }

  async re_evaluate_modal_open(item: any, _index?: any) {
    if (!item?.re_evaluation_required) {
      this.gs.toastr_shows_function('Re-evaluation is not available for this subject. Please contact administrator.', 'Info', 'info');
      return;
    }
    this.selected_item = item;
    this.re_evaluation_reason = '';
    this.re_evaluate_modal?.open();
  }

  cancel_re_evaluate() {
    this.gs.toastr_shows_function('Re-evaluation process cancelled.', 'Info', 'info');
    this.re_evaluate_modal?.close();
  }

  needs_payment(): boolean {
    const details = this.selected_item?.re_evaluation_details;
    return Number(details?.amount ?? 0) > 0;
  }

  async apply_re_evaluation() {
    if (this.is_submitting) return;
    const script_id = this.selected_item?.script_id || this.selected_item?.script?.id;
    if (!script_id) {
      this.gs.toastr_shows_function('Script id missing for this row', 'Error', 'error');
      return;
    }
    if (!this.re_evaluation_reason) {
      this.gs.toastr_shows_function('Please select a reason', 'Error', 'error');
      return;
    }

    this.is_submitting = true;
    try {
      // Single entry point — the BE decides free vs paid internally.
      //   Paid (fees_enabled && PAYMENT_ENABLED): returns billdesk_payload, we redirect to BD.
      //   Free: BE creates the request and returns payment_required=false.
      const res: any = await this.res.initiate_payment({
        script_id,
        reason: this.re_evaluation_reason,
      });

      if (res?.data?.payment_required && res?.data?.billdesk_payload) {
        // Browser navigates away to BillDesk. The user lands back on
        // /re-evaluations?payment=... after the gateway resolves.
        this.submit_billdesk_form(res.data.billdesk_payload);
        return;
      }

      if (res?.code === 200) {
        this.gs.toastr_shows_function(
          'Re-evaluation application submitted successfully.',
          'Success',
          'success',
        );
        this.re_evaluate_modal?.close();
        await this.get_list();
      } else {
        this.gs.toastr_shows_function(res?.message || 'Failed to submit re-evaluation', 'Error', 'error');
      }
    } catch (error: any) {
      const message = error?.error?.message || error?.message || 'Failed to submit re-evaluation';
      this.gs.toastr_shows_function(message, 'Error', 'error');
    } finally {
      this.is_submitting = false;
    }
  }

  // Builds a hidden HTML form from BillDesk's links[1] descriptor and auto-submits
  // it. Pattern copied from the re-evaluation request modal (which mirrors VSBA).
  private submit_billdesk_form(payload: any) {
    const data = payload?.links?.[1];
    if (!data?.href || !data?.parameters) {
      this.gs.toastr_shows_function('Invalid payment payload from server', 'Error', 'error');
      return;
    }
    const form = document.createElement('form');
    form.method = (data.method || 'POST').toUpperCase();
    form.action = data.href;

    const params = { ...data.parameters };
    // BillDesk's embedded SDK expects "merchantid", not "mercid"
    if (params.mercid != null && params.merchantid == null) {
      params.merchantid = params.mercid;
      delete params.mercid;
    }
    Object.keys(params).forEach((key) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(params[key] ?? '');
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }
}
